module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai586-b90afa6d7ba6e00eb91368b9e8c95989.jpg";